module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6b4c7434da0f872e47f75f8b90b1c81d.png";